<template>
  <div class="form-group row">
    <label class="col-md-3 col-form-label d-flex align-self-start">
      <span class="fw-bold">{{ label }}</span>
      <span v-if="required" class="d-flex badge rounded-0 bg-danger align-self-center ms-auto">必須</span>
      <span v-else-if="optional" class="d-flex badge rounded-0 bg-light text-dark align-self-center ms-auto">任意</span>
      <span v-else-if="readonly" class="d-flex badge rounded-0 bg-secondary align-self-center ms-auto">変更不可</span>
    </label>
    <div class="col-md-9 d-flex flex-wrap align-items-center">
      <div class="w-100">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormLayout",
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
  }
}
</script>
